export default __webpack_public_path__ + "static/media/courseSession.3ef68aa2.png";